import { isSupportedCountry, parsePhoneNumberFromString } from "libphonenumber-js";

function isKnownCountry(iso2) {
  return typeof iso2 === "string" && isSupportedCountry(iso2.toUpperCase());
}

// The country a caller already told us about — an explicit `country` prop,
// or one implied by digits already in `value` — always outranks any guess.
export function countryFromDigits(digits) {
  if (!digits) return undefined;
  const parsed = parsePhoneNumberFromString(`+${digits}`);
  return parsed?.country;
}

// Priority: explicit `country` prop > country implied by an already-provided
// `value` > `defaultCountry`. No locale/IP/remembered-choice guessing — the
// field always starts on Ukraine (+380) unless a caller or an existing value
// says otherwise.
export function detectInitialCountrySync({ value, country, defaultCountry = "UA" } = {}) {
  if (isKnownCountry(country)) return country.toUpperCase();

  const fromValue = countryFromDigits(value);
  if (isKnownCountry(fromValue)) return fromValue;

  return isKnownCountry(defaultCountry) ? defaultCountry.toUpperCase() : "UA";
}
